<template>
    <base-modal :title="modalTitle" disallow-shadow-close class="survey-modal">
        <loading-indicator v-if="$loading('survey-modal')" />
        <div v-else>
            <div v-if="currentElement === null">
                <div v-if="surveyProgress === null">
                    {{ survey.description }}
                </div>
                <div v-else-if="survey.outro_text">
                    {{ survey.outro_text }}
                </div>
            </div>
            <div v-else>
                <div v-html="currentElement.text" />
                <div v-if="currentElement.type === 0">
                    <div class="alert alert-danger" v-if="errorText">
                        {{ errorText }}
                    </div>
                    <text-area v-model="answers[currentElement.id_survey_element]" @input="textAreaChange($event.target)" />
                </div>
                <div v-else-if="currentElement.type === 1">
                    <div v-if="currentElement.data.multiSelection">
                        <checkbox v-for="option in currentElement.options"
                                  :key="option.id_survey_select_option"
                                  :label="option.value"
                                  :name="option.id_survey_select_option"
                                  v-model="answers[currentElement.id_survey_element].value"
                        />
                        <div v-if="currentElement.data.hasCustomAnswer">
                            <checkbox name="0" label="Sonstiges" v-model="answers[currentElement.id_survey_element].value" />
                            <form-element v-if="answers[currentElement.id_survey_element].value.includes('0')" label="Bitte angeben" class="mt-2" v-model="answers[currentElement.id_survey_element].custom_answer" />
                        </div>
                    </div>
                    <div v-else>
                        <radio v-for="option in currentElement.options"
                               :key="option.id_survey_select_option"
                               :label="option.value"
                               :set="option.id_survey_select_option"
                               v-model="answers[currentElement.id_survey_element].value"
                        />
                        <div v-if="currentElement.data.hasCustomAnswer">
                            <radio set="0" label="Sonstiges" v-model="answers[currentElement.id_survey_element].value" />
                            <form-element v-if="answers[currentElement.id_survey_element].value === '0'" label="Bitte angeben" class="mt-2" v-model="answers[currentElement.id_survey_element].custom_answer" />
                        </div>
                    </div>
                </div>
                <div v-else-if="currentElement.type === 2" class="d-flex justify-content-around">
                    <div class="d-flex">
                        <icon :name="getRatingName(currentElement.id_survey_element, index)"
                              class="mdi-24px rating-element"
                              v-for="index in currentElement.data.count" :key="index"
                              @click="handleRating(currentElement.id_survey_element, index)"
                        />
                    </div>
                </div>
            </div>
            <div class="mt-3 d-flex justify-content-between">
                <btn theme="secondary" label="Zurück" @click="decreaseProgressStep()" v-if="surveyProgress > 0 && surveyProgress < questions.length - 1"/>
                <div v-else></div>
                <btn :theme="increaseButtonTheme" :label="increaseButtonLabel" :class="increaseButtonDisabled ? 'disabled' : ''" @click="increaseProgressStep()"/>
            </div>
        </div>
    </base-modal>
</template>

<style lang="scss">
    .survey-modal {
        .rating-element {
            &:hover {
                cursor: pointer;
            }
        }
    }
</style>

<script>
    import Survey from "../models/surveyModel";

    export default {
        props: {
            id_survey: {type: [Number, String], required: true},
            test_mode: {type: [Boolean], default: false},
            app: {type: [String], default: 'backend'},
        },

        data() {
            return {
                surveyProgress: null,
                questions: [],
                answers: {},
                testArray: [],
                errorText: null,
            };
        },

        computed: {

            hasInputValue() {
                if (!this.currentElement) {
                    return true;
                }

                switch (this.currentElement.type) {
                    case 0://text
                        return this.answers[this.currentElement.id_survey_element].length > 0;
                    case 1://selection
                        // eslint-disable-next-line no-case-declarations
                        let element = this.answers[this.currentElement.id_survey_element];

                        //custom validation for custom answer
                        // eslint-disable-next-line no-case-declarations
                        let multiSelection = this.currentElement.data.multiSelection;
                        // eslint-disable-next-line no-case-declarations
                        let hasCustomAnswer = this.currentElement.data.hasCustomAnswer;
                        // eslint-disable-next-line no-case-declarations
                        let valueNotNull = element.value !== null;
                        // eslint-disable-next-line no-case-declarations
                        let valueIsArray = Array.isArray(element.value);


                        if (multiSelection) {
                            let valueNotZero = !element.value.includes("0");

                            return (!hasCustomAnswer && valueIsArray && element.value.length > 0)
                                || (hasCustomAnswer && ((valueIsArray && element.value.length > 0 && valueNotZero) || element.custom_answer.length > 0));

                        }
                        return (!hasCustomAnswer && valueNotNull)
                            || (hasCustomAnswer && ((valueNotNull && element.value !== "0") || element.custom_answer.length > 0));

                    default:
                    case 2://stars
                        return this.answers[this.currentElement.id_survey_element] !== undefined;
                }
            },

            survey() {
                return Survey.query().withAll().find(this.id_survey);
            },

            currentElement() {
                if (this.surveyProgress === null || this.surveyProgress === this.survey.survey_elements.length) {
                    return null;
                } else {
                    return this.questions[this.surveyProgress];
                }
            },

            modalTitle() {
                let result = "Umfrage";
                if (this.survey) {
                    result += ` - ${this.survey.title}`;
                }
                return result;
            },

            isLastQuestion() {
                return this.surveyProgress === this.questions.length - 1;
            },

            increaseButtonLabel() {
                if (this.survey) {
                    if (this.surveyProgress === null) {
                        return "Umfrage starten";
                    } else if (this.surveyProgress >= this.questions.length) {
                        return "Schließen";
                    } else if (this.isLastQuestion) {
                        return "Umfrage abschließen";
                    } else {
                        return "Weiter";
                    }
                }
                return "Weiter";
            },

            increaseButtonTheme() {
                if (this.surveyProgress >= this.questions.length) {
                    return "secondary";
                } else if (this.isLastQuestion) {
                    return "danger";
                } else {
                    return "success";
                }
            },

            increaseButtonDisabled() {

                if (this.currentElement && this.currentElement.type === 0 && this.currentElement.mandatory) {
                    this.validateTextAnswer();
                    if (this.errorText) {
                        return true;
                    }
                }

                return this.currentElement !== null && this.currentElement.mandatory && !this.hasInputValue;
            },
        },

        methods: {
            textAreaChange() {
                this.validateTextAnswer();
            },

            increaseProgressStep() {
                if (this.currentElement && this.currentElement.type === 0) {
                    this.validateTextAnswer();
                    if (this.errorText) {
                        return;
                    }
                }
                if (this.isLastQuestion) {
                    if (!this.test_mode) {
                        this.submitAnswers();
                        if (this.survey.outro_text) {
                            this.surveyProgress++;
                        } else {
                            this.$emit('close');
                        }
                    }
                    return;
                } else if (this.surveyProgress === this.questions.length && this.survey.outro_text) {
                    this.$emit('close');
                    return;
                }
                if (this.surveyProgress === null) {
                    this.surveyProgress = 0;
                } else {
                    this.surveyProgress++;
                }
            },

            decreaseProgressStep() {
                if (this.surveyProgress === 0) {
                    this.surveyProgress = null;
                } else {
                    this.surveyProgress--;
                }
            },

            handleRating(step, value) {
                this.$set(this.answers, step, value);
            },

            getRatingName(step, index) {
                if (!this.answers[step] || this.answers[step] < index) {
                    return 'star-outline';
                } else {
                    return 'star';
                }
            },

            validateTextAnswer() {
                if (this.currentElement.data.minLength &&
                    this.answers[this.currentElement.id_survey_element].length < this.currentElement.data.minLength) {
                    this.errorText = `Deine Antwort muss mindestens ${this.currentElement.data.minLength} Zeichen beinhalten.`;
                    return;
                }

                if (this.currentElement.data.maxLength &&
                    this.answers[this.currentElement.id_survey_element].length > this.currentElement.data.maxLength) {
                    this.errorText = `Deine Antwort darf maximal ${this.currentElement.data.maxLength} Zeichen beinhalten`;
                    return;
                }

                if (!this.currentElement.data.minLength && this.currentElement.mandatory && this.answers[this.currentElement.id_survey_element].length === 0) {
                    this.errorText = `Bitte Text ausfüllen!`;
                    return;
                }

                this.errorText = null;

            },

            async submitAnswers() {
                Object.keys(this.answers).forEach(key => {
                    let answer = this.answers[key];
                    if (answer.custom_answer && answer.custom_answer.length) {
                        let question = this.questions.find(question => question.id_survey_element == key);
                        if (question.data.multiSelection) {
                            let zeroIndex = answer.value.findIndex(e => e === "0");
                            answer.value.splice(zeroIndex, 1);
                            answer.value.push(answer.custom_answer);
                        } else {
                            answer.value = answer.custom_answer;
                        }
                    }
                });
                await this.$store.dispatch(`${this.app}/saveSurveyAnswer`, {
                    id_survey: this.id_survey,
                    id_user: this.$store.getters['auth/getUser'].id_user,
                    answers: this.answers,
                });
            },
        },

        async created() {
            this.$loading('survey-modal', true);
            await this.$store.dispatch(`${this.app}/fetchSurvey`, {id_survey: this.id_survey});

            let surveyElements = JSON.parse(JSON.stringify(this.survey.survey_elements));
            let lastPredecessor = null;

            while (surveyElements.length) {
                let index = surveyElements.findIndex(e => e.id_predecessor === lastPredecessor);
                if (index >= 0) {
                    this.questions.push(surveyElements[index]);
                    switch (surveyElements[index].type) {
                        case 0:
                            this.answers[surveyElements[index].id_survey_element] = "";
                            break;
                        case 1:
                            if (surveyElements[index].data.multiSelection) {
                                this.$set(this.answers, surveyElements[index].id_survey_element, {
                                    value: [],
                                    custom_answer: "",
                                });
                            } else {
                                this.$set(this.answers, surveyElements[index].id_survey_element, {
                                    value: null,
                                    custom_answer: "",
                                });
                            }
                            break;
                    }
                    lastPredecessor = surveyElements[index].id_survey_element;
                    surveyElements.splice(index, 1);
                } else {
                    break;
                }
            }
            this.$loading('survey-modal', false);
        },
    };
</script>